<div class="row column" *ngIf="showTarget">
	<div class="progress" role="progressbar" [attr.aria-valuenow]="percentage" aria-valuemin="0" [attr.aria-valuetext]="percentage + ' percent'" aria-valuemax="100">
		<div class="progress-meter" [style.width]="(percentage > 100? 100 : percentage) + '%'" *ngIf="percentage > 0">
			<span class="text show-for-large" *ngIf="(percentage >= 60 && percentage < 70) || percentage > 80">{{ 'progress.current' | translate }}</span>
			<span class="percentage"  *ngIf="percentage >= 40">
				<ng-container *ngIf="showMoneyValue == false">{{ percentage | number: '1.0-0' }}% {{ 'progress.of' | translate }}</ng-container>
				<ng-container *ngIf="showMoneyValue == true">{{ amount | number: '1.0-0' }} {{ 'progress.of' | translate }}</ng-container>
				<span *ngIf="percentage >= 70">
					{{ target | number: '1.0-0' }} {{ currencySymbol }}
					<ng-container *ngIf="showDonors && size != 'small'">({{ donators }} {{ 'progress.donators' | translate }})</ng-container>
				</span>
			</span>
		</div>
		<span class="text" *ngIf="percentage < 40">
			<span class="show-for-large" *ngIf="percentage < 20">{{ 'progress.current' | translate }} </span>
			<ng-container *ngIf="showMoneyValue == false">{{ percentage | number: '1.0-0' }}% {{ 'progress.of' | translate }}</ng-container>
			<ng-container *ngIf="showMoneyValue == true">{{ amount | number: '1.0-0' }} {{ 'progress.of' | translate }}</ng-container>
		</span>
		<span class="target" *ngIf="percentage < 70">
			{{ target | number:'1.0-0' }} {{ currencySymbol }}
			<ng-container *ngIf="showDonors && size != 'small' && percentage < 55">({{ donators }} {{ 'progress.donators' | translate }})</ng-container>
		</span>
	</div>
</div>

<div class="row" *ngIf="showStand && !showTarget">
	<div class="column medium-8 medium-offset-2">
		<div class="progress stand" [innerHTML]="'progress.stand' | translate: {amount: (amount | number: '1.0-0'), currency: currencySymbol}"></div>
	</div>
</div>
